
import React, { useState } from "react";


export default function productdetailsfooter(props) {
    return (
        <div className="detail-footer-new">
            <div className="">
                <button
                    name={"Report abuse"}
                    onClick={(e) => { props?.onClick(e) }}
                    className={"btn btn-link detail-footer-link " }
                    style={{padding:'8px',}}
                >
                    {"Report abuse"}
                </button>
                <a href={"https://qrcode-stt.com/terms-of-service"}
                    target="_blank"
                    name={"Terms of Service"}
                    className={"btn btn-link detail-footer-link "}
                    style={{padding:'8px'}}
                >
                    {"Terms of Service"}
                </a>
                <a href={"https://qrcode-stt.com/privacy-policy"} target="_blank"
                    name={"Terms of Service"}
                    className={"btn btn-link detail-footer-link "}
                    style={{padding:'8px'}}

                >
                    {"Privacy Policy"}
                </a>
            </div>
            <div className='mt-2'>
           
                    {"Powered by "} &nbsp; <img src="../assets/img/logo/STT-Logo.png" width='15px' height='20px'/>&nbsp; {"Scan to Tell (STT)"}
                
            </div>
        </div>
    );
};